export default __webpack_public_path__ + "static/media/carousel_bg_new.b36792bc.svg";